import { createContext } from 'react';

const InviteUserModalContext = createContext({
  role: null,
  parentUserId: null,
  setRole: () => {},
});

export default InviteUserModalContext;
